<template>
  <el-drawer
    title="网格机构管理"
    :visible.sync="dialogVisible"
    direction="rtl"
    :before-close="handleClose"
    :close-on-press-escape="false"
    :wrapperClosable="false"
    size="720px"
    append-to-body
  >
    <div class="container-dialog">
      <el-form
        :inline="true"
        label-position="top"
        :model="formInline"
        class="demo-form-inline"
        ref="form"
        :rules="rules"
      >
        <div class="content">
          <div class="left">
            <el-form-item label="名称" style="width: 100%;" prop="name">
              <el-input
                v-model="formInline.name"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="publicServiceType">
              <el-select
                v-model="formInline.publicServiceType"
                placeholder="请选择类型"
              >
                <el-option
                  v-for="item in publicServiceTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="所属社区"
              style="margin-right:0;width:50%;"
              prop="communityCode"
            >
              <el-select
                v-model="formInline.communityCode"
                placeholder="请选择所属社区"
                @change="commcommunityChange"
              >
                <el-option
                  v-for="item in commcommunityList"
                  :key="item.id"
                  :label="item.pointName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属网格" prop="blockCode">
              <el-select
                v-model="formInline.blockCode"
                placeholder="请选择所属网格"
              >
                <el-option
                  v-for="item in blockList"
                  :key="item.id"
                  :label="item.pointName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="所属网格" style="margin-right:0;width:50%;">
              <el-select
                v-model="formInline.companyGroup"
                placeholder="所属网格"
              >
                <el-option
                  v-for="item in companyGroupOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="所属网格" style="margin-right:0;width:50%;">
              <el-input
                v-model="formInline.grid"
                placeholder="所属网格"
              ></el-input>
            </el-form-item>
          </div>
          <div class="right">
            <el-upload
              class="avatar-uploader"
              :class="{ 'list-pic': picFilesJson.length }"
              action="#"
              :on-remove="handleRemove"
              :file-list="picFilesJson"
              :limit="1"
              list-type="picture-card"
              accept=".jpg,.png,.jpeg"
              :multiple="false"
              :http-request="uploadPicFileFun"
            >
              <i style="font-size: 48px;" class="el-icon-upload"></i><br />
              <span class="el-upload__text"> 上传照片 </span><br />
              <span class="tip">
                只支持.jpg,.png,.jpeg格式
              </span>
            </el-upload>
          </div>
        </div>
        <el-form-item label="所属小区/城中村" style="width: 100%;">
          <el-input
            v-model="formInline.villagesInCity"
            placeholder="所属小区/城中村"
          ></el-input>
        </el-form-item>
        <el-form-item label="详细地址" style="width: 100%;" prop="address">
          <el-input
            v-model="formInline.address"
            placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="中心经度" style="width:210px;">
          <el-input v-model="formInline.longitude" placeholder="中心经度">
            <template slot="append">°E</template>
          </el-input>
        </el-form-item>
        <el-form-item label="中心纬度" style="width:60%;">
          <div style="display:flex;">
            <el-input
              style="width:210px;"
              v-model="formInline.latitude"
              placeholder="中心纬度"
            >
              <template slot="append">°N</template></el-input
            >
            <el-button
              @click="mapVisible = true"
              type="text"
              style="margin-left: 16px;"
              >地图定位</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="联系人" style="width:30%;" prop="contacts">
          <el-input
            v-model="formInline.contacts"
            placeholder="联系人"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式" style="width:30%;" prop="contactsPhone">
          <el-input
            v-model="formInline.contactsPhone"
            placeholder="请输入联系方式"
          ></el-input>
        </el-form-item>
        <el-form-item label="开放时间" prop="openingTime" style="width:30%;">
          <el-date-picker
            v-model="formInline.openingTime"
            type="datetime"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="简介" style="width: 100%;" prop="brief">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8 }"
            v-model="formInline.brief"
            placeholder="请输入简介"
            show-word-limit
            style="white-space: pre-wrap;"
            ref="brief"
            maxlength="2000"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="是否前台展示"
          style="width: 100%;"
          prop="isFrontDisplayed"
        >
          <el-switch
            v-model="formInline.isFrontDisplayed"
            active-value="0"
            inactive-value="1"
            active-color="#0495FF"
          >
          </el-switch>
        </el-form-item>
      </el-form>
    </div>
    <div class="demo-drawer__footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading"
        >确 定</el-button
      >
    </div>
    <mapSearch
      @cancel="mapVisible = false"
      @map-confirm="confirmLocation"
      :visible="mapVisible"
    ></mapSearch>
  </el-drawer>
</template>

<script>
import {
  addBlockOrganization,
  updateBlockOrganization,
  uploadFile,
  getBlockOrganizationById
} from "@/api/block.js";
import mapSearch from "@/components/map-search/index.vue";
import index from "../index";
import moment from "moment";
export default {
  components: { mapSearch },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  mixins: [index],
  data() {
    return {
      mapVisible: false,
      formInline: {
        name: "",
        publicServiceType: "",
        communityCode: "",
        blockCode: "",
        grid: "",
        villagesInCity: "",
        address: "",
        longitude: "",
        latitude: "",
        contacts: "",
        contactsPhone: "",
        openingTime: "",
        brief: "",
        isFrontDisplayed: "0",
        picUrls: "",
        id: ""
      },
      loading: false,
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        publicServiceType: [
          { required: true, message: "请选择类型", trigger: "blur" }
        ],
        communityCode: [
          { required: true, message: "请选择所属社区", trigger: "blur" }
        ],
        blockCode: [
          { required: true, message: "请选择所属网格", trigger: "blur" }
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
        contacts: [
          { required: true, message: "请输入联系人", trigger: "blur" }
        ],
        contactsPhone: [
          { required: true, message: "请输入联系方式", trigger: "blur" }
        ],
        brief: [{ required: true, message: "请输入简介", trigger: "blur" }],
        isFrontDisplayed: [
          { required: true, message: "请选择是否前台展示", trigger: "blur" }
        ],
        openingTime: [
          { required: true, message: "请选择开放时间", trigger: "blur" }
        ]
      },
      picFilesJson: []
    };
  },
  mounted() {
    if (this.curItem.id) {
      this.getBlockOrganizationByIdFun();
    }
  },
  methods: {
    async getBlockOrganizationByIdFun() {
      const res = await getBlockOrganizationById({
        id: this.curItem.id
      });
      this.formInline = res.data.data;
      this.$set(
        this.formInline,
        "isFrontDisplayed",
        res.data.data.isFrontDisplayed || "1"
      );
      if (this.formInline.communityCode)
        this.getblockAllByCommunityIdFun(this.formInline.communityCode);
      this.picFilesJson = [];
      if (this.formInline.picUrls)
        this.picFilesJson.push({
          url: this.formInline.picUrls
        });
    },
    confirmLocation(e) {
      this.lnglat = e;
      this.formInline.longitude = e.lng;
      this.formInline.latitude = e.lat;
      this.formInline.address = e.addr;
      this.mapVisible = false;
    },
    handleRemove() {
      this.picFilesJson = [];
      this.formInline.picUrls = "";
    },
    uploadPicFileFun(file) {
      if (
        !file.file.name.endsWith(".jpg") &&
        !file.file.name.endsWith(".png") &&
        !file.file.name.endsWith(".jpeg")
      ) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.jpg,.png,.jpeg",
          type: "warning"
        });
        return;
      }
      this.uploadFileFun(file, "gh_block_organization");
    },
    async uploadFileFun(file, type) {
      let formData = new FormData();
      formData.append("file", file.file);
      formData.append("objectName", type);
      const res = await uploadFile(formData);
      if (res.data.code === 200) {
        this.picFilesJson = [];
        this.picFilesJson.push({
          ...res.data.data,
          name: res.data.data.fileName,
          url:
            process.env.VUE_APP_API_DOMAIN +
            "/unified-code/file/download?filePath=" +
            res.data.data.filePath
        });
        this.formInline.picUrls =
          process.env.VUE_APP_API_DOMAIN +
          "/unified-code/file/download?filePath=" +
          res.data.data.filePath;
      }
    },
    async onSubmit() {
      let xx = true;
      this.$refs["form"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      this.loading = true;
      let res = null;
      this.formInline.openingTime = this.formInline.openingTime
        ? moment(this.formInline.openingTime).format("YYYY-MM-DD HH:mm:ss")
        : null;
      if (this.curItem.id) {
        res = await updateBlockOrganization(this.formInline);
      } else {
        res = await addBlockOrganization(this.formInline);
      }
      this.loading = false;
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    }
  },
  computed: {},
  watch: {
    "formInline.brief": {
      deep: true,
      handler: function(newVal, oldVal) {
        if (!!!newVal) return;

        this.$nextTick(() => {
          const inputElement = this.$refs.brief.$el.querySelector("textarea");
          const cursorPosition = inputElement.selectionStart;
          this.formInline.brief = newVal.replace(/ /g, "\u3000");
          inputElement.setSelectionRange(cursorPosition, cursorPosition);
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
/deep/#el-drawer__title {
  height: 64px;
  margin-bottom: 0;
  padding: 24px 16px 16px 24px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #494c4f;
}
.container-dialog {
  padding: 14px 24px 24px;
}
/deep/.el-form-item {
  width: calc(50% - 12px);
  margin-bottom: 20px;
  margin-right: 8px;
  .el-form-item__label {
    margin: 0;
    padding: 0;
    margin-bottom: 8px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #494c4f;
    line-height: 1;
  }
  .el-select {
    width: 100%;
  }
  .el-input__inner {
    height: 40px;
    width: 100%;
  }
}
/deep/.demo-drawer__footer {
  width: 100%;
  padding: 24px;
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  background: #fff;
}
.content {
  display: flex;
  .left {
    width: calc(100% - 228px);
  }
  .right {
    margin-left: 16px;
    margin-top: 20px;
    width: 212px;
    height: 212px;
    .el-upload-list,
    /deep/.el-upload,
    /deep/.el-upload-dragger {
      width: 212px;
      height: 212px;
    }
    /deep/.el-upload .el-upload__input {
      display: none;
    }
  }
}
.el-upload__text {
  height: auto;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 16px;
  color: #494c4f;
  display: inline-block;
  margin: 8px 0;
}
.tip {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #92979c;
  margin-top: 8px;
}
/deep/.el-upload--picture-card {
  line-height: 1;
  padding-top: 54px;
}
.list-pic {
  /deep/.el-upload--picture-card {
    display: none;
  }
  /deep/.el-upload-list--picture-card {
    img {
      width: 212px;
      height: 212px;
    }
  }
}
/deep/.container-dialog {
  padding-bottom: 112px;
}
</style>



// WEBPACK FOOTER //
// src/pages/streetInfo/blockOrganization/components/addDialog.vue